<div style="text-align: center; margin-top: 20px" [style.width]="width">
	<div *ngFor="let label of labels; let i = index" style="display: inline-block; margin-right: 15px">
		<div class="bullet" [style.backgroundColor]="colors[i]">&nbsp;</div>
		{{ label }}
	</div>
</div>
